import { useEffect } from "react";
import { TextSwitch, withSkeletonLoading } from "@landtechnologies/components";
import { Stores, useGlobalState } from "react-migration/lib/persistence/state";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { MeasurementSystem } from "src/js/stores/user/store";
import { useSiteById } from "react-migration/domains/sites/hooks/useSiteById";
import { Dimensions } from "react-migration/domains/sites/components/Dimensions";
import { Description } from "react-migration/domains/sites/components/Description";
import logSiteCardEvent from "src/js/view/sites/logSiteCardEvent";

export const Overview = withSkeletonLoading(({ hideSkeletonLoading }) => {
  const { t } = useTranslation();
  const [{ siteCardId }] = useGlobalState(Stores.site);
  const [, { updateMeasurementSystemPreference, getMeasurementSystemPreference, saveUser }] =
    useGlobalState(Stores.user);

  const { loading, site } = useSiteById(siteCardId);

  useEffect(() => {
    !loading && hideSkeletonLoading();
  }, [loading]);

  if (!site) return <div className="atlas-h-[290px]" />;

  const onUnitChange = async (unit: MeasurementSystem) => {
    updateMeasurementSystemPreference(unit);
    await saveUser();
    logSiteCardEvent({
      name: "Site Card Summary Tab - Unit Type Updated",
      context: { type: unit, source: "sitecard-lite" },
    });
  };

  return (
    <div className="atlas-p-4 atlas-z-0">
      <div className="atlas-border-b atlas-border-neutral-200 atlas-pb-4 atlas-flex atlas-justify-between atlas-content-center">
        <span className="atlas-font-medium atlas-text-xl atlas-text-neutral-800">
          {t("sites.card.summary.overview")}
        </span>
        <TextSwitch<MeasurementSystem>
          value={getMeasurementSystemPreference()}
          name="unitType"
          label={t("sites.card.summary.unit_type")}
          widthClass={"atlas-min-w-[140px]"}
          onChange={onUnitChange}
          options={[
            { label: t("sites.card.summary.imperial"), value: MeasurementSystem.IMPERIAL },
            { label: t("sites.card.summary.metric"), value: MeasurementSystem.METRIC },
          ]}
        />
      </div>

      <div className="divide atlas-divide-y atlas-divide-neutral-200">
        <div className="atlas-pt-4">
          <Dimensions geometry={site.geometry} />
        </div>

        <div className="atlas-pt-4">
          <Description siteId={site._id} value={site.notes} />
        </div>
      </div>
    </div>
  );
});
